import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { HeaderTitle } from '@app/shared/common/header-title/header-title.model';
import { HeaderTitleService } from '@app/shared/common/header-title/header-title.service';
import { ModalDeletePopupComponent } from '@app/shared/common/modal-popup/modal-delete-popup/modal-delete-popup.component';
import { ModalPopupComponent } from '@app/shared/common/modal-popup/modal-popup/modal-popup.component';
import { BreadcrumbItem } from '@app/shared/common/sub-header/sub-header.component';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppComponentBase } from '@shared/common/app-component-base';
import { BlobHelperServiceProxy, CityMasterDto, ClientContactCreateOrEditDto, ClientCreateOrEditDto, ClientServiceProxy, CompanyProfileCountryLookupTableDto, CompanyProfileServiceProxy, CountryMasterDto, CountryStateCityAppserviceServiceProxy, SettingScopes, StateMasterDto, StoreImageOnBlobDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { finalize, filter, map } from 'rxjs/operators';
import { SignupWarningModalComponent } from '../../../../account/shared/signup-warning-modal/signup-warning-modal.component';
import { ChargeLateFeesComponent } from './charge-late-fees/charge-late-fees.component';
import { CurrencyLanguageComponent } from './currency-language/currency-language.component';
import { SendPaymentRemainderComponent } from './send-payment-remainder/send-payment-remainder.component';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import { AppConsts } from '@shared/AppConsts';


@Component({
    selector: 'app-create-or-edit-client',
    templateUrl: './create-or-edit-client.component.html',
    styleUrls: ['./create-or-edit-client.component.css']
})
export class CreateOrEditClientComponent extends AppComponentBase implements OnInit {
    @ViewChild('clientForm', { static: true }) clientForm: NgForm;
    @ViewChild('sendPaymentReminderSetting', { static: true }) sendPaymentReminderSetting: SendPaymentRemainderComponent;
    @ViewChild('chargeLateFee', { static: true }) chargeLateFeesComponent: ChargeLateFeesComponent;
    @ViewChild('currencyLanguage', { static: true }) currencyLanguageComponent: CurrencyLanguageComponent;
    @ViewChild("appModalPopup") appModalPopup: ModalPopupComponent;
    @ViewChild("appModaldeletePopup") appModaldeletePopup: ModalDeletePopupComponent;
    @Output() clientAdded: EventEmitter<void> = new EventEmitter<void>();
    @ViewChild("appChangeRouteModalPopup") appChangeRouteModalPopup: ModalPopupComponent;
    @ViewChild('orgMobPhone', { static: true }) orgMobPhoneNgModel: NgModel;
    ActiveClient = "Active Client";
    isLoading = false;
    addForm1stTime = false;
    toggleChecked = false;
    toggleSetting = false;
    ison1 = false;
    ison2 = false;
    imagePath = '';
    isFormDisabled = false;
    subHeaderText = '';
    subHeaderText1 = '';
    option: number;
    allCountry: CompanyProfileCountryLookupTableDto[] = [];
    editIndexClientContactData = -1;
    visited = [0, 0, 0];
    number = ['Charge', 'Setting', 'Currency'];
    checked = false;
    flagselected = '';
    clientData: ClientCreateOrEditDto = new ClientCreateOrEditDto();
    clientContactData: ClientContactCreateOrEditDto[] = [];
    singleContactDetail: ClientContactCreateOrEditDto = new ClientContactCreateOrEditDto();
    defaultTimezoneScope: SettingScopes = SettingScopes.User;
    roleOptions = [{ roleId: 1, roleName: this.l('TechnicalContact') }, { roleId: 2, roleName: this.l('BillingContact') }];
    isSubmited = false;
    isEmailExist = false;
    isPrimaryContactAdded = false;
    clientId: number;
    IsAddingContact = false;
    statebycountryId: StateMasterDto[] = [];
    CityList : CityMasterDto[] = [];
    allCountryCOde: CountryMasterDto[] = [];
    //routerSub: Subscription;
    navigationUrl: string;
    indexTodeleteClientContact: number;
    dateTime = new Date();
    msg: string;
    existingEmail: string;
    isOnlySpaceInString: boolean = false;
    isdisablestate:boolean = true
    isdisablecity: boolean = true
    mobilephoneFlag: string = ''
    timmer: any
    Phonecountrycode: string;
    validatenymber: boolean = true;
    mobilenumber: boolean = true;

    constructor(injector: Injector,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _blobHelperServiceProxy: BlobHelperServiceProxy,
        private _spinnerService: NgxSpinnerService,
        private _clientServiceProxy: ClientServiceProxy,
        private headerTitleService: HeaderTitleService,
        private toastr: ToastrService,
        private _companyProfilesServiceProxy: CompanyProfileServiceProxy,
        private _userServiceProxy: UserServiceProxy,
        private _abpSessionService: AbpSessionService,
        private _monitorService: MonitoringService,
        private _countryStateCityAppserviceServiceProxy :CountryStateCityAppserviceServiceProxy) {
        super(injector);
    }

    ngOnInit(): void {
        this.msg = "userId = " + this._abpSessionService.userId + "tenantId =" + this._abpSessionService.tenantId;
        this._monitorService.logPageView("UI-CreateOrEdit");
        // To remove the duplicate API call "getAllCountryForTableDropdown" as it was not being used
        // this.getCompanyProfile();

        this.clientId = Number(this._activatedRoute.snapshot.queryParams.ClientId);
        this.option = Number(this._activatedRoute.snapshot.queryParams.option);
        this.clientId = Number(history.state.ClientId);
        // if(!this.clientId)this._router.navigate(['/app/main/client-new/client-new-managment']);
        this.option = Number(history.state.option);
        this.show(this.clientId);
        if (this.option === 1) {
            this.isFormDisabled = false;
            this.subHeaderText1 = this.l('ActiveClients');
            this.subHeaderText = this.l('EditClient');
        } else if (this.option === 2) {
            this.isFormDisabled = false;
            this.subHeaderText1 = this.l('ActiveClients');
            this.subHeaderText = this.l('EditClient');
        }
        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem(this.l('Clients')),
            new BreadcrumbItem(this.subHeaderText1),
            new BreadcrumbItem(this.subHeaderText)
        ]));
        this.GetallCountryCOde();
    }



    ngOnDestroy(): void {

    }


    //For confirm leave form guard
    canceledSaved: boolean = false;
    shouldConfirmBeforeLeavingComponent() {
        return !this.canceledSaved;
    }

    //For confirm leave form guard
    changeRoute: any;
    changeRouteResolve: any;
    changeRouteReject: any;
    async showChangeRouteModal() {

        var component = this;

        return new Promise<boolean>((resolve, reject) => {
            this.spinnerService.hide();
            this.appChangeRouteModalPopup.show(2);

            component.changeRouteResolve = resolve;
            component.changeRouteReject = reject;
        });
    }

    changeRouteModalYes(event) {

        this.changeRouteResolve(true);
    }

    changeRouteModalCancel() {
        this.changeRouteResolve(false);
    }




    toggleOnoffevent(event) {
        if (!this.sendPaymentReminderSetting.isCheck && !this.addForm1stTime) {
            this.sendPaymentReminderSetting.addForm();
            this.addForm1stTime = true;
        }
        this.ison2 = !this.ison2;
    }
    changechargeonoff(event) {
        if (this.chargeLateFeesComponent.isCheck) {
            this.chargeLateFeesComponent.isCheck = event.target.checked;
        }
        this.ison1 = !this.ison1;
    }
    changeCharge(event) {
        this.toggleChecked = event;
        this.ison2 = !this.ison2;
    }

    chargeLateFeeFunction(event) {
        this.toggleSetting = event;
        this.ison1 = !this.ison1;
    }

    displayCounter(count) {
        this.imagePath = count;
    }

    // To remove the duplicate API call "getAllCountryForTableDropdown" as it was not being used

    // getCompanyProfile() {
    //     this._companyProfilesServiceProxy.getAllCountryForTableDropdown().subscribe(result => {
    //         this.allCountry = result.filter((country) => {
    //             return country.displayName !== '';
    //         }).sort((a, b) => a.displayName.localeCompare(b.displayName));
    //     });
    // }

    show(clientId?: number) {
        this.subHeaderText1 = this.l('ActiveClients');
        this.subHeaderText = this.l('NewClient');
        if (clientId) {
            this.isLoading = true;

            this._spinnerService.show();
            this._clientServiceProxy.getClientById(clientId).subscribe(result => {
                this._spinnerService.hide();
                this.imagePath = result.clientImageURL;
                this.clientData = result;
                if (result.chargeLateFee !== undefined) {
                    result.chargeLateFee.charelateFeeTaxDetail = result.charelateFeeTaxDetail;
                }

                this.clientData.countryId = result.countryId;

                // this.clientData.timeZone = this.getUniqueArray(result.timeZone);
                this.clientContactData = result.clientContacts;
                this.clientContactData.forEach(contact => {
                    if (contact.isPrimary) {
                        this.isPrimaryContactAdded = true;
                    }
                })
                if (result.paymentReminder.length !== 0) {
                    // this.getPaymentReminderData(result.paymentReminder);
                    this.ison2 = true;
                }
                if (result.chargeLateFee !== undefined) {
                    if (result.chargeLateFee.invoiceValue !== 0 || result.chargeLateFee.invoiceValue !== 0) {
                        // this.getChargeLateData(result.chargeLateFee);
                        //this.chargeLateFeesComponent.TaxDataEditForCommonComponent(result.charelateFeeTaxDetail);
                        this.ison1 = true;
                    }
                }
                this.getStateByCountryId(result.countryId)
                this.getcityByStateId(result.state)

                // this.currencyAndLanguage(result.currencyId, result.applicationLanguageId);


            });
        }

    }




    //getUniqueArray(data) {

    //    let dataArr = data.map(item => {

    //        return [item.id, item];
    //    });

    //    let maparr = new Map(dataArr);

    //    return [...maparr.values()] as any;

    //}


    // getPaymentReminderData(reminders) {
    //     this.sendPaymentReminderSetting.paymentReminderResult(reminders);
    // }

    // getChargeLateData(lateFee) {
    //     this.chargeLateFeesComponent.chargeLateFeeResult(lateFee);
    // }

    // currencyAndLanguage(curemcyId, languageId) {

    //     this.currencyLanguageComponent.currencyAndLanguage(curemcyId, languageId);
    // }

    close() {
        this.appModalPopup.show(2);
        //this._router.navigate(['/app/main/client-new/client-new-managment']);
    }
    cancelNavigationtoUser() {

    }
    navigateToClient() {
        this.canceledSaved = true;
        if (this.navigationUrl) {
            this._router.navigate([this.navigationUrl]);
            return;
        }

        this._router.navigate(['/app/main/client-new/client-new-managment']);
        this.clientAdded.emit();

    }

    //Not allow to insert Special character by keybord
    keyPressAlphaNumeric(event) {
        var inp = String.fromCharCode(event.keyCode);
        if (/[a-zA-Z0-9\w\s]/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }
    keyPressAlphabatesonly(event) {
        //if (event.keyCode == 32) return false;
        var inp = String.fromCharCode(event.keyCode);
        if (/^[a-zA-Z ]*$/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    keyPressAlphabatesvalidation(event) {
        if (event.keyCode == 32) return false;
        var inp = String.fromCharCode(event.keyCode);
        if (/^[a-zA-Z ]*$/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }



    save() {
        if (this.clientForm.form.valid) {
            this._monitorService.logTrace("UI-Save", { "SaveClient ": "start: " + this + this.dateTime })

            this.clientForm.form.markAllAsTouched();

            var inp = this.clientData.name;
            var res = inp.trim();
            if (res == '') {
                this.isOnlySpaceInString = true;
                return;
            }
            else {
                this.isOnlySpaceInString = false;

            }

            if (this.isOnlySpaceInString) {
                return;
            }
            if (this.clientForm.valid && this.clientData.countryId) {
                this.canceledSaved = true;
                if (this.clientData.id) {
                    // this.saveClientData();
                    this.checkDuplicate(this.clientData.name, this.clientData.id, true);
                } else {
                    this.checkDuplicate(this.clientData.name);
                }
            }
            else {
                return;
            }
            this._monitorService.logTrace("UI-Save", { "SaveClient ": "Completed: " + this + this.dateTime })
        }

    }

    deletePicture() {
        this.imagePath = '';
    }

    addContact(event) {
        this._monitorService.logEvent("addContact", { "addContact": "Start: " + this.msg + this.dateTime });

        event.stopPropagation();
        this.IsAddingContact = true;
        if (this.isEmailExist) {
            return;
        }
        else if (this.singleContactDetail.phoneNumber?.length < 10 || !this.mobilenumber || (!this.validatenymber)) {
            return;
        }
else if (this.singleContactDetail.firstName && this.singleContactDetail.phoneNumber
            && this.singleContactDetail.firstName && this.singleContactDetail.clientContactRoleId
            && this.clientForm.controls['email'].valid) {
            if (this.singleContactDetail.isPrimary) this.isPrimaryContactAdded = true;
            //this.singleContactDetail.lastName = this.singleContactDetail.firstName;
            if (this.editIndexClientContactData === -1) {
                this.singleContactDetail.firstName = this.singleContactDetail.firstName.trim();
                this.singleContactDetail.lastName = this.singleContactDetail.lastName.trim();
                this.clientContactData.push(this.singleContactDetail);
                this.singleContactDetail = new ClientContactCreateOrEditDto();
                this.mobilephoneFlag = ''
            } else if(!this.isEmailExist){

                this.singleContactDetail.clientId = this.clientContactData[this.editIndexClientContactData].clientId;
                this.singleContactDetail.id = this.clientContactData[this.editIndexClientContactData].id;

                this.clientContactData[this.editIndexClientContactData] = this.singleContactDetail;
            }
            this.IsAddingContact = false;
            this.editIndexClientContactData = -1;
            this.singleContactDetail = new ClientContactCreateOrEditDto();
            this.singleContactDetail.lastName = null;
            this.singleContactDetail.firstName = null;
            this.singleContactDetail.email = null;
            this.singleContactDetail.phoneNumber = null;
            this.singleContactDetail.clientContactRoleId = null;
        }
        this._monitorService.logEvent("addContact", { "addContact": "Completed: " + this.msg + this.dateTime });

    }

    removefromClientContactData(index: number, contactData: ClientContactCreateOrEditDto) {
        this.indexTodeleteClientContact = index;
        this.appModaldeletePopup.show();
        //   this.clientContactData.splice(index, 1);
        //   if(contactData.isPrimary)this.isPrimaryContactAdded = false;
    }

    editfromClientContactData(index: number) {
        this._monitorService.logEvent("editfromClientContactData", { "editfromClientContactData": "Editcontact:index no= " + index + this.msg + this.dateTime });
        this.isEmailExist = false;

        this.editIndexClientContactData = index;
        if (this.clientContactData[index].isPrimary) this.isPrimaryContactAdded = false;
        this.singleContactDetail.firstName = this.clientContactData[index].firstName;
        this.singleContactDetail.lastName = this.clientContactData[index].lastName;
        this.singleContactDetail.email = this.clientContactData[index].email;
        this.existingEmail = this.clientContactData[index].email;
        this.singleContactDetail.phoneNumber = this.clientContactData[index].phoneNumber;
        this.singleContactDetail.isPrimary = this.clientContactData[index].isPrimary;
        this.singleContactDetail.clientContactRoleId = this.clientContactData[index].clientContactRoleId;

        if (this.singleContactDetail.phoneNumber)
      {
            this.GetallCountryCOde();

        }
    }


    toggleEditMode() {
        this.isFormDisabled = !this.isFormDisabled;
        this.subHeaderText = this.isFormDisabled ? this.l('ViewClient') : this.l('EditClient');
    }

    companyNameAlreadyExists: boolean = false;
    checkDuplicate(clientName: string, clientId?: number, isEdit?: boolean) {

        this._clientServiceProxy.checkDuplicateClient(clientName, clientId, isEdit).subscribe((res) => {
            if (!res) {
                this.companyNameAlreadyExists = false;
                this.saveClientData();
            } else {
                this.companyNameAlreadyExists = true;
            }
        });
    }

    NameVerify(clientName: string, clientId?: number, isEdit?: boolean) {
        if (clientName == ' ') {
            return;
        }
        this._clientServiceProxy.checkDuplicateClient(clientName, clientId, isEdit).subscribe((result) => {
            if (result == true) {
                this.companyNameAlreadyExists = true;
            } else {
                this.companyNameAlreadyExists = false;
            }
        });
    }

    onlyNumberKey(event) {
        if (event.charCode === 45) return true;
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }

    // To return title case string
    getTitleCase(s: string) {
        let char = s[0].toUpperCase();
        return char + s.slice(1)?.toLowerCase();
    }

    saveClientData() {
        try {
            this._monitorService.logEvent("saveClientData", { "saveClientData": "Start: " + this.msg + this.dateTime });
            if (!this.isPrimaryContactAdded) {
                abp.message.warn("Add a Primary Contact");
                return;
            }
            this.isLoading = true;
            this._spinnerService.show();
            if (this.clientContactData.length > 0) {
                if (this.isSubmited) return;
                this.isSubmited = true;
                //To make client contacts first and last name title case
                this.clientContactData.forEach(x => {
                    x.firstName = this.getTitleCase(x.firstName);
                    x.lastName = this.getTitleCase(x.lastName);
                })
                this.clientData.clientContacts = this.clientContactData;

                let blobImgDto = new StoreImageOnBlobDto();
                blobImgDto.imgBase64String = this.imagePath ? this.imagePath.split(',')[1] : null;
                blobImgDto.tenantId = this.appSession.tenant.id;
                this._blobHelperServiceProxy.getUrlAfterImageBlobStorage(blobImgDto).subscribe(imgLink => {
                    this.clientData.clientImageURL = imgLink ? this.imagePath : this.imagePath;
                    if (this.clientData.id === 0 || this.clientData.id === undefined || this.clientData.id === null) {
                        // this.clientData.paymentReminder = this.sendPaymentReminderSetting.paymentReminderSetting();
                        // this.clientData.chargeLateFee = this.chargeLateFeesComponent.chargeLateFee();
                        // this.clientData.currencyId = this.currencyLanguageComponent.getCurrencyId();
                        // this.clientData.applicationLanguageId = this.currencyLanguageComponent.getLanguageId();
                        //this.clientData.charelateFeeTaxDetail=this.chargeLateFeesComponent.TaxDataFromCommonComponent();
                    } else {
                        // this.clientData.paymentReminder = this.sendPaymentReminderSetting.paymentReminderSetting();

                        // if (this.chargeLateFeesComponent.chargeLateFee().feeValueType != undefined) {
                        //     this.clientData.chargeLateFee.feeValueType = this.chargeLateFeesComponent.chargeLateFee().feeValueType === null || this.chargeLateFeesComponent.chargeLateFee().feeValueType === undefined ? this.clientData.chargeLateFee.feeValueType : this.chargeLateFeesComponent.chargeLateFee().feeValueType;
                        //     this.clientData.chargeLateFee.days = this.chargeLateFeesComponent.chargeLateFee().days === null || this.chargeLateFeesComponent.chargeLateFee().days === undefined ? this.clientData.chargeLateFee.days : this.chargeLateFeesComponent.chargeLateFee().days;
                        //     this.clientData.chargeLateFee.invoiceValue = this.chargeLateFeesComponent.chargeLateFee().invoiceValue === null || this.chargeLateFeesComponent.chargeLateFee().invoiceValue === undefined ? this.clientData.chargeLateFee.invoiceValue : this.chargeLateFeesComponent.chargeLateFee().invoiceValue;
                        //     this.clientData.chargeLateFee.charelateFeeTaxDetail = this.chargeLateFeesComponent.chargeLateFee().charelateFeeTaxDetail === null || this.chargeLateFeesComponent.chargeLateFee().charelateFeeTaxDetail === undefined ? this.clientData.chargeLateFee.charelateFeeTaxDetail : this.chargeLateFeesComponent.chargeLateFee().charelateFeeTaxDetail;
                        // }

                        //   this.clientData.charelateFeeTaxDetail=this.chargeLateFeesComponent.TaxDataFromCommonComponent() === null || this.chargeLateFeesComponent.TaxDataFromCommonComponent() === undefined ? this.clientData.charelateFeeTaxDetail : this.chargeLateFeesComponent.TaxDataFromCommonComponent();
                        //this.clientData.charelateFeeTaxDetail=this.chargeLateFeesComponent.TaxDataFromCommonComponent();

                        // this.clientData.currencyId = this.currencyLanguageComponent.getCurrencyId();
                        // this.clientData.applicationLanguageId = this.currencyLanguageComponent.getLanguageId();
                    }
                    this._monitorService.logTrace("UI-saveClientData", { "saveClientData ": "CreateOrEdit:called " + this + this.dateTime + "InputData:" + null })
                    //if(this.isSubmited) return;
                    this.clientData.country = null;
                    this.clientData.city = this.clientData.city === null ? 0 : this.clientData.city;
                    this.clientData.state = this.clientData.state === null ? 0 : this.clientData.state; 
                    this._clientServiceProxy.createOrEdit(this.clientData)
                        .pipe(finalize(() => {
                            this._spinnerService.hide();
                        }))
                        .subscribe(() => {
                            //this.toastr.info(this.l('Saved Successfully'));
                            this.clientData.id ? this.toastr.success(this.l("Changesupdatedsuccessfully")) : this.toastr.success(this.l("Newclientaddedsuccessfully"));
                            this.isSubmited = false;

                            this.clientAdded.emit();
                            this._router.navigate(['/app/main/client-new/client-new-managment']);
                        });
                })

            } else {
                this._monitorService.logTrace("UI-saveClientData", { "saveClientData ": "Please add At least one contact person: " + this + this.dateTime })
                this._spinnerService.hide();
                abp.message.info('', this.l('PleaseaddatleastoneContactPerson'));
            }
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    SelectedCountry(event: CompanyProfileCountryLookupTableDto) {
        if (!event) this.flagselected = '';
        this.allCountry.forEach(x => { if (x.id === event.id) this.flagselected = x.flag });
    }
    
    countryselection(event: any) {
//clear previous data
this.clientData.state=null;
this.clientData.city=null;
this.statebycountryId=null;
this.CityList=null;

        this.clientData.countryId = event;
        this.getStateByCountryId(event)

    }
    stateselection(event: any) {

        this.clientData.countryId = event;

    }


    EmailVerify(value: any) {
        let result = value.toLowerCase();
        // if (value == this.existingEmail) { return false; }

        if(result) {
            this.isCheckEmail(value).then((result) => {
                if (result == true) {
                    this.isEmailExist = true;
                } else {
                    this.isEmailExist = false;
                }

            }).then(() => {
                let emailExist = this.clientContactData.find(x => x.email === value);
                if (emailExist) {
                    this.isEmailExist = true;
                }
            });
        }
        else {
            this.isEmailExist = false;
        }
    }

    isCheckEmail(value: any) {
        let promise = new Promise((resolve, reject) => {

            this._userServiceProxy.isCheckEmail(value).subscribe((res) => {

                resolve(res);

            }, (_error) => {

                reject(false);

            });

        });

        return promise;

    }



    getFullname(name: string, lastname: string) {
        return name + " " + lastname;
    }


    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }

    onModalYesClick(id) {
        if (this.clientContactData[this.indexTodeleteClientContact].isPrimary) this.isPrimaryContactAdded = false;
        this.clientContactData.splice(this.indexTodeleteClientContact, 1);
    }

    onModalCancelClick() {
    }

    onCompanyChange() {
        this.companyNameAlreadyExists = false;
        this.isOnlySpaceInString = false;
    }

    SelectedCity(event : any){
        this.clientData.city = event.id;
      }


    filterCountryCOde: CountryMasterDto[] = [];

      getStateByCountryId(countryId: number ) {
        this._countryStateCityAppserviceServiceProxy.getStateByCountryId(countryId).subscribe(result => {
            this.statebycountryId = result.filter((country) => {
                return country.name !== '';
            }).sort((a, b) => a.name.localeCompare(b.name));
            this.isdisablestate = false

        });
      }

      getcityByStateId(stateId :number) {
        this._countryStateCityAppserviceServiceProxy.getCityByCountryId(stateId).subscribe(result => {
            this.CityList = result.filter((country) => {
                return country.name !== '';
            }).sort((a, b) => a.name.localeCompare(b.name));
            this.isdisablecity = false
        });
      }
      SelectedState(event : any){
        this.getcityByStateId(event.id)
        this.clientData.state = event.id;
    }


    GetallCountryCOdess(event: any) {
        {


            const phoneUtil = PhoneNumberUtil.getInstance();
            if (event && this.Phonecountrycode !== undefined) {
                if (phoneUtil.regionToMetadataMap !== undefined) {
                    if (event.toString().length > 8 && event.toString().length <= 17 && /^\(\+\s?\d{1,4}\)[\d\s]+$/.test(event)) {
                        const number = phoneUtil.parseAndKeepRawInput(event.toString(), this.Phonecountrycode);
                        this.validatenymber = phoneUtil.isValidNumberForRegion(number, this.Phonecountrycode);
                    }
                    else {
                        this.validatenymber = false;
                    }

                } else {
                    this.validatenymber = false;
                }
            } else {
                this.validatenymber = false;
            }

        }
    }
    MobilenumberValidation(event: any) {
        const phoneUtil = new PhoneNumberUtil.getInstance();
        if (!/^\(\+\s?\d{1,4}\)[\d\s]+$/.test(event)) { this.mobilenumber = false; return;}
        if (event && !isNaN(event) && /^\(\+\s?\d{1,4}\)[\d\s]+$/.test(event)) {
            const number = phoneUtil?.parseAndKeepRawInput(event?.toString(), this.Phonecountrycode);
            this.mobilenumber = phoneUtil?.isValidNumberForRegion(number, this.Phonecountrycode)
            this.orgMobPhoneNgModel.control.setErrors(!this.mobilenumber ? { 'invalid': this.mobilenumber } : null);
        } else {
            this.mobilenumber = true;
        }
    }

    BusinessPhone(selectedText: CountryMasterDto) {
        this.singleContactDetail.phoneNumber = '';
        this.mobilephoneFlag = selectedText?.tld;
        this.Phonecountrycode = selectedText?.iso2;
        var code = !selectedText?.phone_code.includes("+") ? '+' + selectedText.phone_code : selectedText.phone_code
        this.singleContactDetail.phoneNumber = '(' + code + ')' + this.singleContactDetail.phoneNumber
    }

    filterItems(value: string) {
        const filterValue = value.toLowerCase();
        if (filterValue)
            this.filterCountryCOde = this.allCountryCOde.filter(option => option.phone_code.toLowerCase().includes(filterValue));
        else
            this.filterCountryCOde = this.allCountryCOde
    }

    checknumber() {
        if (this.singleContactDetail.phoneNumber) {
            let regex = /\((\+\d+)\)/;
            let match = regex.exec(this.singleContactDetail.phoneNumber);
            let valueBetweenBrackets = match ? match[1].substring(1) : null;
            var aaa = this.allCountryCOde.find((country) => country.phone_code.replace('+', '') === valueBetweenBrackets)
            this.Phonecountrycode = aaa?.iso2
            this.mobilephoneFlag = aaa?.tld
            this.GetallCountryCOdess(this.singleContactDetail.phoneNumber)
        }
    }

    GetallCountryCOde() {
        if (!AppConsts.allCountry) {
            this._countryStateCityAppserviceServiceProxy.getAllCountry().subscribe(result => {
                AppConsts.allCountry = result; this.GetallCountryCOdeAfterApi(result);
            });
        } else { this.GetallCountryCOdeAfterApi(AppConsts.allCountry); }
    }
    GetallCountryCOdeAfterApi(result) {
        this.allCountryCOde = result.filter((country) => {
            return country.phone_code !== '';
        }).sort((a, b) => a.phone_code.localeCompare(b.phone_code));
        this.checknumber();
    }
}
